import * as React from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	CaseTypeType,
	useWorkplaceCaseTypesQuery,
} from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useEffect, useMemo } from 'react';
import Loading from '../../../../Components/Loading';
import { useAppContext } from '../../../../Services/AppContext';
import useTranslation from '../../../../Hooks/useTranslation';
import { isString } from 'lodash';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue | string;
	error?: FieldError;
	workplaceId?: string;
	portal?: boolean;
	excludedIds?: string[];
}

const WorkplaceOrganizationUnitSelect: React.FC<Props> = props => {
	const { value, onChange, workplaceId, portal = false, excludedIds } = props;
	const { userData } = useAppContext();
	const { t } = useTranslation();

	const { data, isLoading } = useWorkplaceCaseTypesQuery({
		workplaceId: workplaceId ?? userData.workplaceId,
		caseTypeTypes: [CaseTypeType.Folder],
	});

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		console.log('data', data);
		console.log('excludedIds', excludedIds);

		for (const workplaceCaseType of data?.workplaceCaseTypes?.data || []) {
			if (workplaceCaseType) {
				if (!excludedIds?.some(item => item === workplaceCaseType?.id)) {
					items.push({
						value: workplaceCaseType?.caseType?.id,
						label: workplaceCaseType?.caseType?.label || '',
					});
				}
			}
		}

		return items;
	}, [data]);

	useEffect(() => {
		if (isString(value)) {
			const newValue = options.find(item => item.value === value);
			if (onChange && newValue) {
				onChange(newValue);
			}
		}
	}, [value, options]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			value={value}
			placeholder={t('base.shared.pick')}
			portal={portal}
			isClearable
		/>
	);
};

export default WorkplaceOrganizationUnitSelect;
